export default "__VITE_ASSET__B$WnfQtd__"